export default __webpack_public_path__ + "static/media/hasharon1.85d81a1d.jpg";